import {
    FETCH_RECALCULATE_HOUR_REQUEST,
    FETCH_RECALCULATE_HOUR_SUCCESS,
    FETCH_RECALCULATE_HOUR_FAILURE
  } from "../../Constants";
  
  import { managerTimesheet } from "../../Api/managerTimesheet";
  
  function requestRecalculateHour() {
    return {
      type: FETCH_RECALCULATE_HOUR_REQUEST,
      isFetching: true
    };
  }
  
  function fetchRecalculateHourSuccess(data) {
    return {
      type: FETCH_RECALCULATE_HOUR_SUCCESS,
      isFetching: false,
      data
    };
  }
  
  function fetchRecalculateHourError(errorMessage) {
    return {
      type: FETCH_RECALCULATE_HOUR_FAILURE,
      isFetching: false,
      errorMessage
    };
  }
  
  export const fetchRecalculateHour = payload => (dispatch, getState) => {
    dispatch(requestRecalculateHour());
    managerTimesheet
      .fecthRequestHour(payload)
      .then(res => {
        dispatch(fetchRecalculateHourSuccess(res));
      })
      .catch(err => dispatch(fetchRecalculateHourError(err)));
  };
  